<template>
  <div class="px-8">
    <v-card class="pb-3 mb-10 rounded-10 elevation-card mt-4">
      <v-card-title>
        <span
          class="font-weight-700 fs-20 lh-16 pl-1 bluedarken--text text-uppercase"
          style="align-self: center"
        >
          {{ tab === 'all' ? 'SN Indonesia' : tab }}
        </span>
        <v-spacer></v-spacer>
        <v-icon
          color="bluedarken"
          style="font-size: 22px !important"
          id="refreshBudget"
          @click="refresh"
        >
          refresh
        </v-icon>
      </v-card-title>
      <v-card-text class="px-3 py-2 consolidate-monthly">
        <v-row xs12 class="px-2 pl-5">
          <span class="font-weight-bold fs-14 align-self-center">
            YTD
          </span>
          <span class="pl-3 font-weight-bold fs-14 align-self-center">
            :
            {{
              itemsTable.length !== 0
                ? formatMonthYear(itemsTable[0].monthly_report)
                : '-'
            }}
          </span>
          <v-spacer></v-spacer>
          <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="btn-column"
                class="primary--text pb-0 mr-3"
                depressed
                color="lightblue"
                v-bind="attrs"
                v-on="on"
              >
                Select Column
              </v-btn>
            </template>
            <v-list-item-group
              v-model="columnActive"
              multiple
              class="menuColumn"
            >
              <div
                class="px-4 py-2"
                @click="selectAllColumn()"
                style="cursor:pointer;"
              >
                <v-row>
                  <v-flex xs2 class="ml-4" style="max-width: 37px !important;">
                    <v-icon v-if="isSelectedAll" color="primary accent-4">
                      check_box
                    </v-icon>
                    <v-icon color="primary accent-4" v-else>
                      check_box_outline_blank
                    </v-icon>
                  </v-flex>
                  <v-flex xs8 class="pt-1">
                    <v-list-item-title class="text-left">
                      Select All
                    </v-list-item-title>
                  </v-flex>
                </v-row>
              </div>
              <template v-for="(item, i) in columnTable">
                <v-divider v-if="!item" :key="`divider-${i}`"></v-divider>
                <v-list-item
                  v-else
                  :key="`item-${i}`"
                  :value="item"
                  class="text-left"
                  style="max-height: 48px !important;"
                  active-class="primary--text text--accent-4"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-content style="max-width: 20px !important;">
                    </v-list-item-content>

                    <v-list-item-action style="width: 100%">
                      <v-flex xs12>
                        <v-row>
                          <v-flex xs2 style="max-width: 37px !important">
                            <v-icon color="primary accent-4" v-if="active">
                              check_box
                            </v-icon>
                            <v-icon v-else color="primary accent-4">
                              check_box_outline_blank
                            </v-icon>
                          </v-flex>
                          <v-flex xs8>
                            <v-list-item-title class="text-left" v-text="item">
                            </v-list-item-title>
                          </v-flex>
                        </v-row>
                      </v-flex>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-menu>
        </v-row>
        <v-col sm="12" class="px-2">
          <!-- :server-items-length="totalItems"
            :footer-props="{
              itemsPerPageOptions: [10, 25, 50, 100]
          }" -->
          <!-- {{itemsTable}} -->
          <v-simple-table fixed-header class="table-taxonomy nav-table mt-1">
            <template v-slot:default>
              <v-perfect-scroll
                class="drawer-menu--scroll-consolidatePO"
                :settings="scrollSettings"
              >
                <thead>
                  <tr>
                    <th
                      v-if="columnActive.includes('Department')"
                      class="f-14 white--text"
                    >
                      Department
                      <filter-column
                        field="dept"
                        @sortAsc="getAscSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('dept')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Brand/Division')"
                      class="f-14 white--text"
                    >
                      Brand/Division
                      <filter-column
                        field="brand_division"
                        @sortAsc="getAscSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('brand_division')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('PO Number')"
                      class="f-14 white--text"
                    >
                      PO Number
                      <filter-column
                        field="po_number"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('po_number')"
                        @filterItem="searchCln"
                        :isCode="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('PO Date')"
                      class="f-14 white--text"
                    >
                      PO Date
                      <filter-column
                        field="po_date"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('formatted_po')"
                        @filterItem="searchCln"
                        :isDate="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Vendor Number')"
                      class="f-14 white--text"
                    >
                      Vendor Number
                      <filter-column
                        field="vendor_number"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('vendor_number')"
                        @filterItem="searchCln"
                        :isCode="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Vendor Name')"
                      class="f-14 white--text"
                    >
                      Vendor Name
                      <filter-column
                        field="vendor_name"
                        @sortAsc="getAscSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('vendor_name')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Internal Order No')"
                      class="f-14 white--text"
                    >
                      Internal Order No
                      <filter-column
                        field="io_number"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('io_number')"
                        @filterItem="searchCln"
                        :isCode="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Internal Order Description')"
                      class="f-14 white--text"
                    >
                      Internal Order Description
                      <filter-column
                        field="io_description"
                        @sortAsc="getAscSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('io_description')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Cost Element')"
                      class="f-14 white--text"
                    >
                      Cost Element
                      <filter-column
                        field="cost_element.code"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('cost_element.code')"
                        @filterItem="searchCln"
                        :isCode="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Cost Element Name')"
                      class="f-14 white--text"
                    >
                      Cost Element Name
                      <filter-column
                        field="cost_element.desc"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('cost_element.desc')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('PO Name')"
                      class="f-14 white--text"
                    >
                      PO Name
                      <filter-column
                        field="po_name"
                        @sortAsc="getAscSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('po_name')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Net Value Currency')"
                      class="f-14 white--text"
                    >
                      Net Value Currency
                      <filter-column
                        field="net_value_currency"
                        @sortAsc="getAscSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('net_value_currency')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('PO Exchange Rate')"
                      class="f-14 white--text"
                    >
                      PO Exchange Rate
                      <filter-column
                        field="po_exchange_rate"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('po_exchange_rate')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('PO Amount')"
                      class="f-14 white--text"
                    >
                      PO Amount
                      <filter-column
                        field="po_amount"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('po_amount')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('GR Amount (LC)')"
                      class="f-14 white--text"
                    >
                      GR Amount (LC)
                      <filter-column
                        field="gr_amount"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('gr_amount')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Invoice Amount (LC)')"
                      class="f-14 white--text"
                    >
                      Invoice Amount (LC)
                      <filter-column
                        field="invoice_amount"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('invoice_amount')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Delivery Date')"
                      class="f-14 white--text"
                    >
                      Delivery Date
                      <filter-column
                        field="delivery_date"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('formatted_delivery')"
                        @filterItem="searchCln"
                        :isDate="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Fiscal Year')"
                      class="f-14 white--text"
                    >
                      Fiscal Year
                      <filter-column
                        field="fiscal_year"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('formatted_fiscal')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="
                        columnActive.includes(
                          'Name of Person who Created the Object'
                        )
                      "
                      class="f-14 white--text"
                    >
                      Name of Person who Created the Object
                      <filter-column
                        field="name_of_person_who_created_the_object"
                        @sortAsc="getAscSort"
                        @searchColumn="searchCln"
                        :listFilter="
                          getFiltered('name_of_person_who_created_the_object')
                        "
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Invoice Document Date')"
                      class="f-14 white--text"
                    >
                      Invoice Document Date
                      <filter-column
                        field="invoice_document_date"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('formatted_invoice')"
                        @filterItem="searchCln"
                        :isDate="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Invoice Posting Date')"
                      class="f-14 white--text"
                    >
                      Invoice Posting Date
                      <filter-column
                        field="invoice_posting_date"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('formatted_posting')"
                        @filterItem="searchCln"
                        :isDate="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Material group')"
                      class="f-14 white--text"
                    >
                      Material group
                      <filter-column
                        field="material_group"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('material_group')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Delv Complete')"
                      class="f-14 white--text"
                    >
                      Delv Complete
                      <filter-column
                        field="delv_complete"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('delv_complete')"
                        @filterItem="searchCln"
                      />
                    </th>
                    <th
                      v-if="
                        columnActive.includes('Net Value PO IDR after closed')
                      "
                      class="f-14 white--text"
                    >
                      Net Value PO IDR after closed
                      <filter-column
                        field="net_value_po_idr"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('net_value_po_idr')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Outstanding PO')"
                      class="f-14 white--text"
                    >
                      Outstanding PO
                      <filter-column
                        field="outstanding_po"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('outstanding_po')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Aging')"
                      class="f-14 white--text"
                    >
                      Aging
                      <filter-column
                        field="aging"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('aging')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('PO Amount IDR')"
                      class="f-14 white--text"
                    >
                      PO Amount IDR
                      <filter-column
                        field="po_amount_idr"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('po_amount_idr')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Close PO')"
                      class="f-14 white--text"
                    >
                      Close PO
                      <filter-column
                        field="close_po"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('close_po')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('PO Amount IDR - YTD')"
                      class="f-14 white--text"
                    >
                      PO Amount IDR - YTD
                      <filter-column
                        field="po_amount_idr_ytd"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('po_amount_idr_ytd')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('GR Amount IDR')"
                      class="f-14 white--text"
                    >
                      GR Amount IDR
                      <filter-column
                        field="gr_amount_idr"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('gr_amount_idr')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('Non PO Amount IDR - YTD')"
                      class="f-14 white--text"
                    >
                      Non PO Amount IDR - YTD
                      <filter-column
                        field="non_po_amount_idr_ytd"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('non_po_amount_idr_ytd')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                    <th
                      v-if="columnActive.includes('GR Amount IDR Non PO')"
                      class="f-14 white--text"
                    >
                      GR Amount IDR Non PO
                      <filter-column
                        field="gr_amount_idr_non_po"
                        @sortAsc="getNestedSort"
                        @searchColumn="searchCln"
                        :listFilter="getFiltered('gr_amount_idr_non_po')"
                        @filterItem="searchCln"
                        :columnType="true"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody v-if="itemsTamp.length > 0">
                  <tr
                    v-for="(val, index) in itemsTamp"
                    :key="'entitiesdata' + index"
                  >
                    <td v-if="columnActive.includes('Department')">
                      {{ val.dept }}
                    </td>
                    <td v-if="columnActive.includes('Brand/Division')">
                      {{ val.brand_division }}
                    </td>
                    <td v-if="columnActive.includes('PO Number')">
                      {{ val.po_number }}
                    </td>
                    <td v-if="columnActive.includes('PO Date')">
                      {{ formatDate(val.po_date) }}
                    </td>
                    <td v-if="columnActive.includes('Vendor Number')">
                      {{ val.vendor_number }}
                    </td>
                    <td v-if="columnActive.includes('Vendor Name')">
                      {{ val.vendor_name }}
                    </td>
                    <td v-if="columnActive.includes('Internal Order No')">
                      {{ val.io_number }}
                    </td>
                    <td
                      v-if="columnActive.includes('Internal Order Description')"
                    >
                      {{ val.io_description }}
                    </td>
                    <td v-if="columnActive.includes('Cost Element')">
                      <v-edit-dialog
                        :return-value.sync="val.cost_element.code"
                        large
                        @save="savePO(val, 'cost_element')"
                        @cancel="cancelPO(val, 'cost_element')"
                      >
                        {{ val.cost_element.code }}
                        <template v-slot:input>
                          <v-autocomplete
                            id="code-group"
                            single-line
                            placeholder="Select Cost Element"
                            :value="val.cost_element"
                            required
                            class="mt-1"
                            :items="costElements"
                            return-object
                            @input="editItem($event, 'cost_element')"
                          >
                            <template slot="selection" slot-scope="data">
                              {{ data.item.code }} - {{ data.item.desc }}
                            </template>
                            <template slot="item" slot-scope="data">
                              {{ data.item.code }} - {{ data.item.desc }}
                            </template>
                          </v-autocomplete>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td v-if="columnActive.includes('Cost Element Name')">
                      {{ val.cost_element.desc }}
                    </td>
                    <td v-if="columnActive.includes('PO Name')">
                      <v-edit-dialog
                        :return-value.sync="val.po_name"
                        large
                        @save="savePO(val, 'po_name')"
                        @cancel="cancelPO(val, 'po_name')"
                      >
                        {{ val.po_name }}
                        <template v-slot:input>
                          <v-text-field
                            @input="editItem($event, 'po_name')"
                            :value="val.po_name"
                            placeholder="Edit"
                            single-line
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td v-if="columnActive.includes('Net Value Currency')">
                      <v-edit-dialog
                        :return-value.sync="val.net_value_currency"
                        large
                        @save="savePO(val, 'net_value_currency')"
                        @cancel="cancelPO(val, 'net_value_currency')"
                      >
                        {{ val.net_value_currency }}
                        <template v-slot:input>
                          <v-text-field
                            @input="editItem($event, 'net_value_currency')"
                            :value="val.net_value_currency"
                            placeholder="Edit"
                            single-line
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="columnActive.includes('PO Exchange Rate')"
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.po_exchange_rate"
                        large
                        @save="savePO(val, 'po_exchange_rate')"
                        @cancel="cancelPO(val, 'po_exchange_rate')"
                      >
                        {{ idr(val.po_exchange_rate) }}
                        <template v-slot:input>
                          <v-text-field
                            @input="editItem($event, 'po_exchange_rate')"
                            :value="val.po_exchange_rate"
                            placeholder="Edit"
                            type="number"
                            single-line
                          ></v-text-field>
                        </template>
                        <!-- <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'po_exchange_rate')"
                            :value="val.po_exchange_rate"
                            placeholder="Edit"
                            single-line
                          /> -->
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="columnActive.includes('PO Amount')"
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.po_amount"
                        large
                        @save="savePO(val, 'po_amount')"
                        @cancel="cancelPO(val, 'po_amount')"
                      >
                        {{ idr(val.po_amount) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'po_amount')"
                            :value="val.po_amount"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="columnActive.includes('GR Amount (LC)')"
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.gr_amount"
                        large
                        @save="savePO(val, 'gr_amount')"
                        @cancel="cancelPO(val, 'gr_amount')"
                      >
                        {{ idr(val.gr_amount) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'gr_amount')"
                            :value="val.gr_amount"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="columnActive.includes('Invoice Amount (LC)')"
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.invoice_amount"
                        large
                        @save="savePO(val, 'invoice_amount')"
                        @cancel="cancelPO(val, 'invoice_amount')"
                      >
                        {{ idr(val.invoice_amount) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'invoice_amount')"
                            :value="val.invoice_amount"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td v-if="columnActive.includes('Delivery Date')">
                      <v-edit-dialog
                        :return-value.sync="val.delivery_date"
                        large
                        @save="savePO(val, 'delivery_date')"
                        @cancel="cancelPO(val, 'delivery_date')"
                      >
                        {{ formatDate(val.delivery_date) }}
                        <template v-slot:input>
                          <date-picker
                            type="date"
                            placeholder="Edit"
                            v-model="itemEdited.delivery_date"
                            class="dashSearch filterSearch mt-2"
                            style="width: 135px !important;"
                            :value="val.delivery_date"
                            @input="editItem($event, 'delivery_date')"
                          >
                          </date-picker>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td v-if="columnActive.includes('Fiscal Year')">
                      <v-edit-dialog
                        :return-value.sync="val.fiscal_year"
                        large
                        @save="savePO(val, 'fiscal_year')"
                        @cancel="cancelPO(val, 'fiscal_year')"
                      >
                        {{ formatDate(val.fiscal_year) }}
                        <template v-slot:input>
                          <date-picker
                            type="date"
                            placeholder="Edit"
                            v-model="itemEdited.fiscal_year"
                            class="dashSearch filterSearch mt-2"
                            style="width: 135px !important;"
                            :value="val.fiscal_year"
                            @input="editItem($event, 'fiscal_year')"
                          >
                          </date-picker>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="
                        columnActive.includes(
                          'Name of Person who Created the Object'
                        )
                      "
                    >
                      <v-edit-dialog
                        :return-value.sync="
                          val.name_of_person_who_created_the_object
                        "
                        large
                        @save="
                          savePO(val, 'name_of_person_who_created_the_object')
                        "
                        @cancel="
                          cancelPO(val, 'name_of_person_who_created_the_object')
                        "
                      >
                        {{ idr(val.name_of_person_who_created_the_object) }}
                        <template v-slot:input>
                          <v-text-field
                            @input="
                              editItem(
                                $event,
                                'name_of_person_who_created_the_object'
                              )
                            "
                            :value="val.name_of_person_who_created_the_object"
                            placeholder="Edit"
                            single-line
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td v-if="columnActive.includes('Invoice Document Date')">
                      <v-edit-dialog
                        :return-value.sync="val.invoice_document_date"
                        large
                        @save="savePO(val, 'invoice_document_date')"
                        @cancel="cancelPO(val, 'invoice_document_date')"
                      >
                        {{ formatDate(val.invoice_document_date) }}
                        <template v-slot:input>
                          <date-picker
                            type="date"
                            placeholder="Edit"
                            v-model="itemEdited.invoice_document_date"
                            class="dashSearch filterSearch mt-2"
                            style="width: 135px !important;"
                            :value="val.invoice_document_date"
                            @input="editItem($event, 'invoice_document_date')"
                          >
                          </date-picker>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td v-if="columnActive.includes('Invoice Posting Date')">
                      <v-edit-dialog
                        :return-value.sync="val.invoice_posting_date"
                        large
                        @save="savePO(val, 'invoice_posting_date')"
                        @cancel="cancelPO(val, 'invoice_posting_date')"
                      >
                        {{ formatDate(val.invoice_posting_date) }}
                        <template v-slot:input>
                          <date-picker
                            type="date"
                            placeholder="Edit"
                            v-model="itemEdited.invoice_posting_date"
                            class="dashSearch filterSearch mt-2"
                            style="width: 135px !important;"
                            :value="val.invoice_posting_date"
                            @input="editItem($event, 'invoice_posting_date')"
                          >
                          </date-picker>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td v-if="columnActive.includes('Material group')">
                      <v-edit-dialog
                        :return-value.sync="val.material_group"
                        large
                        @save="savePO(val, 'material_group')"
                        @cancel="cancelPO(val, 'material_group')"
                      >
                        {{ val.material_group }}
                        <template v-slot:input>
                          <v-text-field
                            @input="editItem($event, 'material_group')"
                            :value="val.material_group"
                            placeholder="Edit"
                            single-line
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td v-if="columnActive.includes('Delv Complete')">
                      <v-edit-dialog
                        :return-value.sync="val.delv_complete"
                        large
                        @save="savePO(val, 'delv_complete')"
                        @cancel="cancelPO(val, 'delv_complete')"
                      >
                        {{ val.delv_complete }}
                        <template v-slot:input>
                          <v-text-field
                            @input="editItem($event, 'delv_complete')"
                            :value="val.delv_complete"
                            placeholder="Edit"
                            single-line
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="
                        columnActive.includes('Net Value PO IDR after closed')
                      "
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.net_value_po_idr"
                        large
                        @save="savePO(val, 'net_value_po_idr')"
                        @cancel="cancelPO(val, 'net_value_po_idr')"
                      >
                        {{ idr(val.net_value_po_idr) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'net_value_po_idr')"
                            :value="val.net_value_po_idr"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="columnActive.includes('Outstanding PO')"
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.outstanding_po"
                        large
                        @save="savePO(val, 'outstanding_po')"
                        @cancel="cancelPO(val, 'outstanding_po')"
                      >
                        {{ idr(val.outstanding_po) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'outstanding_po')"
                            :value="val.outstanding_po"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="columnActive.includes('Aging')"
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.aging"
                        large
                        @save="savePO(val, 'aging')"
                        @cancel="cancelPO(val, 'aging')"
                      >
                        {{ idr(val.aging) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'aging')"
                            :value="val.aging"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="columnActive.includes('PO Amount IDR')"
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.po_amount_idr"
                        large
                        @save="savePO(val, 'po_amount_idr')"
                        @cancel="cancelPO(val, 'po_amount_idr')"
                      >
                        {{ idr(val.po_amount_idr) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'po_amount_idr')"
                            :value="val.po_amount_idr"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="columnActive.includes('Close PO')"
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.close_po"
                        large
                        @save="savePO(val, 'close_po')"
                        @cancel="cancelPO(val, 'close_po')"
                      >
                        {{ idr(val.close_po) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'close_po')"
                            :value="val.close_po"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="columnActive.includes('PO Amount IDR - YTD')"
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.po_amount_idr_ytd"
                        large
                        @save="savePO(val, 'po_amount_idr_ytd')"
                        @cancel="cancelPO(val, 'po_amount_idr_ytd')"
                      >
                        {{ idr(val.po_amount_idr_ytd) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'po_amount_idr_ytd')"
                            :value="val.po_amount_idr_ytd"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="columnActive.includes('GR Amount IDR')"
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.gr_amount_idr"
                        large
                        @save="savePO(val, 'gr_amount_idr')"
                        @cancel="cancelPO(val, 'gr_amount_idr')"
                      >
                        {{ idr(val.gr_amount_idr) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'gr_amount_idr')"
                            :value="val.gr_amount_idr"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="columnActive.includes('Non PO Amount IDR - YTD')"
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.non_po_amount_idr_ytd"
                        large
                        @save="savePO(val, 'non_po_amount_idr_ytd')"
                        @cancel="cancelPO(val, 'non_po_amount_idr_ytd')"
                      >
                        {{ idr(val.non_po_amount_idr_ytd) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'non_po_amount_idr_ytd')"
                            :value="val.non_po_amount_idr_ytd"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                    <td
                      v-if="columnActive.includes('GR Amount IDR Non PO')"
                      class="text-right"
                    >
                      <v-edit-dialog
                        :return-value.sync="val.gr_amount_idr_non_po"
                        large
                        @save="savePO(val, 'gr_amount_idr_non_po')"
                        @cancel="cancelPO(val, 'gr_amount_idr_non_po')"
                      >
                        {{ idr(val.gr_amount_idr_non_po) }}
                        <template v-slot:input>
                          <v-currency-field
                            class="mt-2"
                            @input="editItem($event, 'gr_amount_idr_non_po')"
                            :value="val.gr_amount_idr_non_po"
                            placeholder="Edit"
                            single-line
                          />
                        </template>
                      </v-edit-dialog>
                    </td>
                  </tr>
                  <tr class="bgTotal font-weight-bold text-right">
                    <td
                      v-if="checkColspanTotal() !== 0"
                      :colspan="checkColspanTotal()"
                      class="border-r-0 font-weight-bold sticky-amount"
                    >
                      Total
                    </td>
                    <td
                      v-if="columnActive.includes('PO Amount')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('po_amount', itemsTamp) }}
                    </td>
                    <td
                      v-if="columnActive.includes('GR Amount (LC)')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('gr_amount', itemsTamp) }}
                    </td>
                    <td
                      v-if="columnActive.includes('Invoice Amount (LC)')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('invoice_amount', itemsTamp) }}
                    </td>
                    <td
                      v-if="checkColspanTotal2() !== 0"
                      class="sticky-amount"
                      :colspan="checkColspanTotal2()"
                    ></td>
                    <td
                      v-if="
                        columnActive.includes('Net Value PO IDR after closed')
                      "
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('net_value_po_idr', itemsTamp) }}
                    </td>
                    <td
                      v-if="columnActive.includes('Outstanding PO')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('outstanding_po', itemsTamp) }}
                    </td>
                    <td
                      v-if="columnActive.includes('Aging')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('aging', itemsTamp) }}
                    </td>
                    <td
                      v-if="columnActive.includes('PO Amount IDR')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('po_amount_idr', itemsTamp) }}
                    </td>
                    <td
                      v-if="columnActive.includes('Close PO')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('close_po', itemsTamp) }}
                    </td>
                    <td
                      v-if="columnActive.includes('PO Amount IDR - YTD')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('po_amount_idr_ytd', itemsTamp) }}
                    </td>
                    <td
                      v-if="columnActive.includes('GR Amount IDR')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('gr_amount_idr', itemsTamp) }}
                    </td>
                    <td
                      v-if="columnActive.includes('Non PO Amount IDR - YTD')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('non_po_amount_idr_ytd', itemsTamp) }}
                    </td>
                    <td
                      v-if="columnActive.includes('GR Amount IDR Non PO')"
                      class="sticky-amount"
                    >
                      {{ totalAmountFor_('gr_amount_idr_non_po', itemsTamp) }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="48" class="text-center">
                      No data displayed
                    </td>
                  </tr>
                </tbody>
              </v-perfect-scroll>
            </template>
            <!-- </v-perfect-scroll> -->
          </v-simple-table>
        </v-col>
      </v-card-text>
    </v-card>
    <progress-dialog
      :show="progressDialogLoading"
      text="Please wait"
    ></progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../progress_dialog';
import filterColumn from '../filterColumn';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    'filter-column': filterColumn
  },
  props: {
    itemsTable: {
      type: Array,
      required: true
    },
    tab: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      progressDialogLoading: false,
      scrollSettings: {
        maxScrollbarLength: 260
      },
      costElements: [],
      itemEdited: {
        po_name: '',
        cost_element: {},
        net_value_currency: '',
        po_exchange_rate: '',
        po_amount: '',
        gr_amount: '',
        invoice_amount: '',
        delivery_date: '',
        fiscal_year: '',
        name_of_person_who_created_the_object: '',
        invoice_document_date: '',
        invoice_posting_date: '',
        material_group: '',
        delv_complete: '',
        net_value_po_idr: '',
        outstanding_po: '',
        aging: '',
        po_amount_idr: '',
        close_po: '',
        po_amount_idr_ytd: '',
        gr_amount_idr: '',
        non_po_amount_idr_ytd: '',
        gr_amount_idr_non_po: ''
      },
      itemsTamp: [],
      columnTable: [
        'Department',
        'Brand/Division',
        'PO Number',
        'PO Date',
        'Vendor Number',
        'Vendor Name',
        'Internal Order No',
        'Internal Order Description',
        'Cost Element',
        'Cost Element Name',
        'PO Name',
        'Net Value Currency',
        'PO Exchange Rate',
        'PO Amount',
        'GR Amount (LC)',
        'Invoice Amount (LC)',
        'Delivery Date',
        'Fiscal Year',
        'Name of Person who Created the Object',
        'Invoice Document Date',
        'Invoice Posting Date',
        'Material group',
        'Delv Complete',
        'Net Value PO IDR after closed',
        'Outstanding PO',
        'Aging',
        'PO Amount IDR',
        'Close PO',
        'PO Amount IDR - YTD',
        'GR Amount IDR',
        'Non PO Amount IDR - YTD',
        'GR Amount IDR Non PO'
      ],
      columnActive: [],
      isSelectedAll: true
    };
  },
  computed: {
    itemFull() {
      return this.itemsTable;
    }
  },
  watch: {
    itemsTable(val) {
      this.itemsTamp = val;
    },
    columnActive: {
      handler(val) {
        localStorage.setItem('columnActiveConsolidatePO', JSON.stringify(val));
        if (val.length !== this.columnTable.length) {
          this.isSelectedAll = false;
        } else {
          this.isSelectedAll = true;
        }
      },
      deep: true
    }
    // tab() {
    //   this.checkActiveColumn();
    // }
  },
  created() {
    window.addEventListener('beforeunload', this.handleRefresh);
  },
  mounted() {
    this.itemsTamp = this.itemsTable;
    this.getCostElement();
    this.checkActiveColumn();
  },
  methods: {
    checkActiveColumn() {
      // set active column
      let column = JSON.parse(
        localStorage.getItem('columnActiveConsolidatePO')
      );
      let arrColumn = null;
      if (column) {
        arrColumn = column;
      } else {
        arrColumn = this.columnTable;
      }
      if (this.columnTable !== arrColumn) {
        this.columnActive = arrColumn;
      } else {
        this.columnActive = this.columnTable;
      }
    },
    getCostElement() {
      this.$store
        .dispatch('costElement/getAll', {
          limit: 10000
        })
        .then(data => {
          if (data.code === 200) {
            this.costElements = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    savePO(val) {
      Swal.fire({
        title: '',
        text: 'Are you sure want to edit this data?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.saveData(val);
        }
      });
    },
    saveData(val) {
      this.progressDialogLoading = true;
      let id = val.id;
      let body = {
        cost_element: this.itemEdited.cost_element || val.cost_element,
        po_name: this.itemEdited.po_name || val.po_name,
        net_value_currency:
          this.itemEdited.net_value_currency || val.net_value_currency,
        po_exchange_rate:
          Number(this.itemEdited.po_exchange_rate) || val.po_exchange_rate,
        po_amount: this.itemEdited.po_amount || val.po_amount,
        gr_amount: this.itemEdited.gr_amount || val.gr_amount,
        invoice_amount: this.itemEdited.invoice_amount || val.invoice_amount,
        delivery_date: this.itemEdited.delivery_date || val.delivery_date,
        fiscal_year: this.itemEdited.fiscal_year || val.fiscal_year,
        name_of_person_who_created_the_object:
          this.itemEdited.name_of_person_who_created_the_object ||
          val.name_of_person_who_created_the_object,
        invoice_document_date:
          this.itemEdited.invoice_document_date || val.invoice_document_date,
        invoice_posting_date:
          this.itemEdited.invoice_posting_date || val.invoice_posting_date,
        material_group: this.itemEdited.material_group || val.material_group,
        delv_complete: this.itemEdited.delv_complete || val.delv_complete,
        net_value_po_idr:
          this.itemEdited.net_value_po_idr || val.net_value_po_idr,
        outstanding_po: this.itemEdited.outstanding_po || val.outstanding_po,
        aging: this.itemEdited.aging || val.aging,
        po_amount_idr: this.itemEdited.po_amount_idr || val.po_amount_idr,
        close_po: this.itemEdited.close_po || val.close_po,
        po_amount_idr_ytd:
          this.itemEdited.po_amount_idr_ytd || val.po_amount_idr_ytd,
        gr_amount_idr: this.itemEdited.gr_amount_idr || val.gr_amount_idr,
        non_po_amount_idr_ytd:
          this.itemEdited.non_po_amount_idr_ytd || val.non_po_amount_idr_ytd,
        gr_amount_idr_non_po:
          this.itemEdited.gr_amount_idr_non_po || val.gr_amount_idr_non_po
      };
      this.$store
        .dispatch('monthlyReport/editPO', { id: id, params: body })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            Swal.fire({
              title: 'Success!',
              text: `${data.message.text_en}`,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.refresh();
                this.reset();
              }
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    cancelPO(val, column) {
      this.itemEdited[column] = val[column];
    },
    editItem(val, variable) {
      this.itemEdited[variable] = val;
    },
    reset() {
      this.itemEdited = {
        po_name: '',
        cost_element: {},
        net_value_currency: '',
        po_exchange_rate: '',
        po_amount: '',
        gr_amount: '',
        invoice_amount: '',
        delivery_date: '',
        fiscal_year: '',
        name_of_person_who_created_the_object: '',
        invoice_document_date: '',
        invoice_posting_date: '',
        material_group: '',
        delv_complete: '',
        net_value_po_idr: '',
        outstanding_po: '',
        aging: '',
        po_amount_idr: '',
        close_po: '',
        po_amount_idr_ytd: '',
        gr_amount_idr: '',
        non_po_amount_idr_ytd: '',
        gr_amount_idr_non_po: ''
      };
    },
    refresh() {
      this.$emit('getData');
    },
    handleRefresh() {
      localStorage.setItem(
        'columnActiveConsolidatePO',
        JSON.stringify(this.columnTable)
      );
    },
    selectAllColumn() {
      if (this.isSelectedAll) {
        this.isSelectedAll = false;
        this.columnActive = [];
      } else {
        this.isSelectedAll = true;
        this.columnActive = this.columnTable;
      }
    },
    getAscSort(obj) {
      this.itemsTamp.sort(this.dynamicSort(obj.fieldName));
    },
    getNestedSort(obj) {
      this.nestedSort(obj.fieldName, this.itemsTamp);
    },
    searchCln(obj) {
      let nameField = obj.fieldName;
      let arr = this.itemFull;
      let valSearch = Array.isArray(obj.value)
        ? obj.value.join('|').toLowerCase()
        : obj.value.toLowerCase();
      if (!nameField.includes('.')) {
        /*search array of object*/
        switch (nameField) {
          case 'po_date':
            nameField = 'formatted_po';
            break;
          case 'delivery_date':
            nameField = 'formatted_delivery';
            break;
          case 'fiscal_year':
            nameField = 'formatted_fiscal';
            break;
          case 'invoice_document_date':
            nameField = 'formatted_invoice';
            break;
          case 'invoice_posting_date':
            nameField = 'formatted_posting';
            break;
        }
        this.itemsTamp = arr.filter(function(a) {
          if (a[nameField] !== null) {
            if (Array.isArray(obj.value)) {
              return obj.value.includes(a[nameField].toString());
            } else {
              return a[nameField]
                .toString()
                .toLowerCase()
                .match(valSearch);
            }
          }
        });
      } else {
        /*search array of nested object*/
        let arrObj = nameField.split('.');
        if (arrObj.length === 2) {
          this.itemsTamp = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(a[arrObj[0]][arrObj[1]].toString());
              } else {
                return a[arrObj[0]][arrObj[1]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        }
      }
    },
    getFiltered(name) {
      if (!name.includes('.')) {
        let dataFiltered = this.itemFull.reduce((result, arr) => {
          result[arr[name]] = [...(result[arr[name]] || []), arr];
          return result;
        }, {});
        return Object.keys(dataFiltered);
      } else {
        let nameField = name.split('.');
        let dataFiltered = [];
        if (nameField.length === 2) {
          dataFiltered = this.itemFull.reduce((result, arr) => {
            if (!arr[nameField[0]]) return;
            result[arr[nameField[0]][nameField[1]]] = [
              ...(result[arr[nameField[0]][nameField[1]]] || []),
              arr
            ];
            return result;
          }, {});
        }
        return Object.keys(dataFiltered);
      }
    },
    checkColspanTotal() {
      let column = [
        'Department',
        'Brand/Division',
        'PO Number',
        'PO Date',
        'Vendor Number',
        'Vendor Name',
        'Internal Order No',
        'Internal Order Description',
        'Cost Element',
        'Cost Element Name',
        'PO Name',
        'Net Value Currency',
        'PO Exchange Rate'
      ];
      let columnActive = [];
      for (let i = 0; i < column.length; i++) {
        if (this.columnActive.includes(column[i])) {
          columnActive.push(column[i]);
        }
      }
      return columnActive.length;
    },
    checkColspanTotal2() {
      let column = [
        'Delivery Date',
        'Fiscal Year',
        'Name of Person who Created the Object',
        'Invoice Document Date',
        'Invoice Posting Date',
        'Material group',
        'Delv Complete'
      ];
      let columnActive = [];
      for (let i = 0; i < column.length; i++) {
        if (this.columnActive.includes(column[i])) {
          columnActive.push(column[i]);
        }
      }
      return columnActive.length;
    }
  }
};
</script>

<style>
.table-po table {
  display: block;
  border-radius: 5px;
}
.table-po table th,
.table-po table td {
  white-space: nowrap !important;
  height: 30px !important;
}

.table-po table th {
  text-align: center !important;
  font-weight: 500 !important;
  background: #28a0f6;
}
/* width */
.table-po ::-webkit-scrollbar {
  height: 8px;
}
/* Track */
.table-po ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.table-po ::-webkit-scrollbar-thumb {
  background: #d5d5d5;
  border-radius: 20px;
}

/* Handle on hover */
.table-po ::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
.table-po td {
  height: 30px !important;
  border-right: 0.1px solid rgba(0, 0, 0, 0.12);
  border-left: 0.1px solid rgba(0, 0, 0, 0.12);
}
td:hover {
  background-color: #f5f5f5 !important;
}
.drawer-menu--scroll-consolidatePO {
  max-height: 500px;
  overflow: auto;
}
.v-list-item {
  min-height: 40px !important;
  font-size: 12px !important;
}
.v-select__selections {
  min-height: 40px !important;
  font-size: 12px !important;
}
.menuColumn {
  max-height: 250px;
}
.v-menu__content {
  background: #fff !important;
}
</style>
